const FindWidgetAndQueryIdInView = (widgetId, view) => view.state.reduce(
  (foundWidget, state, queryId) => {
    if (foundWidget) {
      return foundWidget;
    }
    const widget = state.widgets.find((w) => w.id === widgetId);
    if (widget) {
      return [widget, queryId];
    }
    return void 0;
  },
  void 0
);
export default FindWidgetAndQueryIdInView;
